const SALES_ORDER_STATUS_BY_MODEL_STATUS = Object.freeze({
  "5": "Closed",
  "8": "Ready to be Invoiced",
  "9": "Invoiced",
});

const LEGACY_SALES_ORDER_STATUS = Object.freeze({
  paid: "Invoiced",
  "paid in full": "Invoiced",
});

export const BILLED_MARGIN_ELIGIBLE_STATUSES = Object.freeze(["Invoiced", "Closed"]);

export function canonicalizeBilledMarginStatus(status) {
  const raw = String(status ?? "").trim();
  if (!raw) return "";
  return SALES_ORDER_STATUS_BY_MODEL_STATUS[raw]
    || LEGACY_SALES_ORDER_STATUS[raw.toLowerCase()]
    || raw;
}

export function isBilledMarginStatus(status) {
  return BILLED_MARGIN_ELIGIBLE_STATUSES.includes(canonicalizeBilledMarginStatus(status));
}

export function getBilledMarginView(status, financials) {
  if (!isBilledMarginStatus(status) || !financials) return null;

  const actualMargin = Number(financials.actualMargin);
  const marginPercent = Number(financials.marginPercent);
  if (!Number.isFinite(actualMargin) || !Number.isFinite(marginPercent)) return null;

  return {
    actualMargin,
    marginPercent,
    revenueSubtotal: Number(financials.revenueSubtotal),
    billedCostNoTax: Number(financials.billedCostNoTax),
    revenueBasisSource: financials.revenueBasisSource || null,
  };
}
